import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import { BaseSocketConnector } from '~/web-frontend-core/api/connector/BaseSocketConnector';
export default class LiveOutcomesTableMobile extends BaseSocketConnector {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.LIVE_OUTCOMES_TABLE_MOBILE;
    }
    getOutcomeData({ id }) {
        return {
            site: this.siteType,
            lng: this.language,
            id,
            timezone: this.timezone,
        };
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/outcomes/live/TableMobile.js